import { IQuickVideo } from 'lib/api/quickVideo/types';
import { useDeleteBatchQuickVideoMutation } from 'lib/api/quickVideo/useDeleteBatchQuickVideoMutation';
import { CheckboxInput, SelectionHeaderPopup } from 'lib/components';
import { Flex } from 'lib/components/styles/layout';
import React from 'react';
import { Button } from 'react-covideo-common';
import { CgSpinnerTwoAlt } from 'react-icons/cg';
import { MdDeleteForever } from 'react-icons/md';

type SelectedQuickVideosRibbonProps = {
  selectedQuickVideos: IQuickVideo[];
  setSelectedQuickVideos: React.Dispatch<React.SetStateAction<IQuickVideo[]>>;
  quickVideos: IQuickVideo[];
};

export const SelectedQuickVideosRibbon = ({
  selectedQuickVideos,
  setSelectedQuickVideos,
  quickVideos,
}: SelectedQuickVideosRibbonProps) => {
  const { mutateAsync: deleteBatch, isLoading: isDeleting } =
    useDeleteBatchQuickVideoMutation({
      onSuccess: () => {
        setSelectedQuickVideos([]);
      },
    });
  if (!selectedQuickVideos.length) {
    return <></>;
  }

  const isChecked =
    selectedQuickVideos.length > 0 &&
    quickVideos.length !== selectedQuickVideos.length;

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target as HTMLInputElement;
    if (checked) {
      setSelectedQuickVideos(quickVideos);
    } else {
      setSelectedQuickVideos([]);
    }
  };

  const handleBatchDelete = async () => {
    await deleteBatch({
      quickVideoIds: selectedQuickVideos.map(qv => qv.quickVideoId),
    });
  };

  return (
    <>
      <SelectionHeaderPopup left='208px'>
        <Flex
          width='100%'
          justifyContent='space-between'
          flexDirection='row'
          alignItems='center'
        >
          <Flex flexDirection='row' alignItems='center' gap='8px'>
            <CheckboxInput
              blueCheck={true}
              checkGroupIndicator={isChecked}
              checked={selectedQuickVideos.length == quickVideos.length}
              ignoreGrayForAllSelect={true}
              grayCheck={true}
              onChange={handleSelectAll}
              disabled={isDeleting}
            />
            <div>Quick Videos selected: {selectedQuickVideos.length}</div>
          </Flex>

          <Button
            text='Delete'
            variant='destructive'
            icon={
              isDeleting ? <CgSpinnerTwoAlt /> : <MdDeleteForever size={18} />
            }
            onClick={handleBatchDelete}
            disabled={isDeleting}
            loading={isDeleting}
          />
        </Flex>
      </SelectionHeaderPopup>
    </>
  );
};
